export enum TransportModeEnum {
    UrbanPublicTransport = 1,
    RegionalPublicTransport = 2,
    LongDistanceTransport = 3
}
